
export default {
  model: {
    prop: 'modelValue',
    event: 'updataModelValue',
  },
  props: {
    type: {
      type: String,
      default: 'text',
    },
    placeholder: {
      type: String,
      default: '',
    },
    modelValue: {
      type: [String, Number],
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    value: {
      get() {
        return this.modelValue
      },
      set(v) {
        this.$emit('updataModelValue', v)
      },
    },
  },
  methods: {
    blur(ev) {
      this.$emit('blur', ev.target.value)
    },
    focus(ev) {
      this.$emit('focus', ev.target.value)
    },
    change(ev) {
      // console.log('disabled',this.disabled)
      console.log('5656',ev.target.value)
      // this.value.set = JSON.parse(JSON.stringify(ev.target.value))
      // this.$set('value', ev.target.value)
      this.$emit('change', ev.target.value)
    },
  },
}
